
export const processResponse = (isSuccess, props, errorMessage = null) => {
    if (props?.setBtnLoading)
        props.setBtnLoading(false);

    if (props?.setLoading)
        props.setLoading(false);

    if (props?.setShowSuccessMessage)
        props.setShowSuccessMessage(isSuccess);

    if (props?.setErrorMessage)
        props.setErrorMessage(isSuccess ? null : errorMessage);
}
